module.exports = __webpack_public_path__ + "img/v2_qt4pj2@2x.98ee1425.png";